export const CUSTOM_FILTER_KEY = 'connext.custom-filters.v1';
export function readCustomFilters() {
  try { return JSON.parse(localStorage.getItem(CUSTOM_FILTER_KEY) || '[]').filter(f => typeof f.id === 'string' && f.id.startsWith('custom-') && typeof f.name === 'string' && Array.isArray(f.layers)).slice(0,20); }
  catch { return []; }
}
export function drawCustomLayers(ctx, landmarks, layers) {
  const average = points => ({x:points.reduce((n,p)=>n+p.x,0)/points.length,y:points.reduce((n,p)=>n+p.y,0)/points.length});
  const left=average(landmarks.getLeftEye()), right=average(landmarks.getRightEye());
  const distance=Math.hypot(right.x-left.x,right.y-left.y);
  const angle=Math.atan2(right.y-left.y,right.x-left.x);
  const middle={x:(left.x+right.x)/2,y:(left.y+right.y)/2};
  const anchors={eyes:middle,nose:average(landmarks.getNose()),mouth:average(landmarks.getMouth()),forehead:{x:middle.x+Math.sin(angle)*distance*.7,y:middle.y-Math.cos(angle)*distance*.7},left,right};
  layers.forEach(layer=>{
    const anchor=anchors[layer.anchor] || middle;
    const x=Number(layer.x)||0,y=Number(layer.y)||0;
    ctx.save();ctx.translate(anchor.x,anchor.y);ctx.rotate(angle);ctx.translate(x*distance,y*distance);ctx.rotate((Number(layer.rotation)||0)*Math.PI/180);
    ctx.fillStyle=/^#[0-9a-f]{6}$/i.test(layer.color)?layer.color:'#d1b2fa';
    ctx.globalAlpha=layer.opacity??1;
    if(layer.kind==='drawing') {
      ctx.scale(distance*layer.size,distance*layer.size);
      ctx.strokeStyle=ctx.fillStyle;ctx.lineWidth=layer.width||.04;ctx.lineCap='round';ctx.lineJoin='round';
      if(layer.glow){ctx.shadowColor=ctx.fillStyle;ctx.shadowBlur=12;}
      const paint=mirror=>{const points=layer.points||[];if(!points.length)return;ctx.beginPath();ctx.moveTo(points[0][0]*mirror,points[0][1]);points.slice(1).forEach(p=>ctx.lineTo(p[0]*mirror,p[1]));if(points.length===1){ctx.lineTo(points[0][0]*mirror+.001,points[0][1]);}ctx.stroke();};
      paint(1);if(layer.mirror)paint(-1);ctx.restore();return;
    }
    ctx.font=`${Math.max(.1,Math.min(2,Number(layer.size)||.5))*distance}px sans-serif`;
    ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText(String(layer.symbol||'✦').slice(0,8),0,0);ctx.restore();
  });
}
